<script setup lang="ts">
import type { ISingleSystemSetupParameter } from '@/api/generator';
import { SetupParameter } from '@/views/tasks/components/types.ts';
import { getSetupParameterName } from '@/views/tasks/utils.ts';

defineProps<{
  parameter: ISingleSystemSetupParameter | SetupParameter;
}>();
</script>

<template>
  <span class="text-body-1 font-weight-bold">
    {{ getSetupParameterName(parameter) }}
  </span>
  <span> | {{ parameter.iuid }}</span>
</template>
